var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"px-4"},[(_vm.isCoupon === true)?_c('Content',{attrs:{"item":_vm.item}}):(_vm.isCoupon === false)?_c('p',{staticClass:"pt-1",attrs:{"align":"center"}},[_vm._v("このクーポンは利用できません")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }